export function useRfqAccess() {
  const auth = useAuth()
  return computed(() => auth.liquidityMe?.canAccessRfqs === true)
}
